import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5436fb93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 0,
  class: "points"
}

import { computed, ref, watch } from 'vue'
import gsap from 'gsap'
import { useGameState, useAppState } from '@/services/composition';
import { Role } from '@/services/states/AppStateMachine';
import { Hotspot, useHotspots } from '@/services/stores/hotspots';
import Delay from '@/core/Delay';

import UITimer from '@/components/UITimer/UITimer.vue';


export const NOTIFICATION_TIMEOUT = 5000

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { state: appState } = useAppState()
const { findHotspot } = useHotspots()

const currentHotspot = ref<Hotspot>(null)

const theme = computed(() => {
  return appState.value.context.role === Role.Companion ? 'light' : 'dark'
})

const displayPoints = computed(() => {
  return `${currentHotspot.value.points > 0 ? '+' : ''}${currentHotspot.value.points} seconds`
})

const hasActionSucceed = computed(() => {
  return currentHotspot.value && currentHotspot.value.points > 0
})

const hasActionFailed = computed(() => {
  return currentHotspot.value && currentHotspot.value.points < 0
})

const eventType = computed(()=>{
  return state.value.event.type
})

const lastDoneHotspot = computed(() => {
  return state.value.context.hotspots.length && state.value.context.hotspots[state.value.context.hotspots.length - 1]
})

const showActionDone = ref(false)
// watch(eventType, async (eventType) => {
//   if (eventType === 'GAME_HOTSPOT_ACTION_DONE') {
//     const id = state.value.event.payload as HotspotId
//     currentHotspot.value = findHotspot(id)
//     console.log(currentHotspot.value, showActionDone.value)
//     if( currentHotspot.value.points !== 0 ){
//       showActionDone.value = true
//       await Delay(NOTIFICATION_TIMEOUT)
//       showActionDone.value = false
//     } else {
//       showActionDone.value = false
//     }
//   }
// })

watch(lastDoneHotspot, async (id) => {
  currentHotspot.value = findHotspot(id)
  if( currentHotspot.value.points !== 0 ){
    showActionDone.value = true
    await Delay(NOTIFICATION_TIMEOUT)
    showActionDone.value = false
  } else {
    showActionDone.value = false
  }
})

const onEnter = (el: HTMLElement, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { yPercent: -100}, { yPercent: 0, duration: 1, ease: 'quint.inOut', clearProps: 'transform' })
}

const onLeave = (el: HTMLElement, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { yPercent: -100, duration: 1, ease: 'quint.inOut' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave,
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['journey-game-state', { 'journey-game-state--action-done': showActionDone.value }, _unref(theme)])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_Transition, {
            name: "medium-fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (currentHotspot.value && showActionDone.value)
                ? (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([
              'background-action-done',
              {
                'background-action-done--success': _unref(hasActionSucceed),
                'background-action-done--fail': _unref(hasActionFailed)
              }
            ]),
                    key: currentHotspot.value.id
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_Transition, {
              name: "medium-fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  class: "room",
                  key: _unref(state).context.metadata.room
                }, _toDisplayString(_unref(state).context.metadata.room), 1))
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              name: "medium-fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_unref(state).matches('tuto'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_Transition, {
                        name: "medium-fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("div", {
                            key: _unref(state).context.metadata.title,
                            class: _normalizeClass(['title-inner', { 'title-inner--alt': _unref(state).matches('tuto.xr.exit_room')}])
                          }, _toDisplayString(_unref(state).context.metadata.title), 3))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock(UITimer, { key: 1 }))
              ]),
              _: 1
            })
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (currentHotspot.value && showActionDone.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_Transition, {
                      name: "medium-fade",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass([
                  'value',
                  {
                    'value--success': _unref(hasActionSucceed),
                    'value--fail': _unref(hasActionFailed)
                  }
                ]),
                          key: currentHotspot.value.id
                        }, _toDisplayString(_unref(displayPoints)), 3))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})